(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('AccessMainCtrl', AccessMainCtrl);

    function AccessMainCtrl() {
        const map = {};
        return {
            // what a cheater. Wonder if this is eating memory.
            setMainControllerScope: (mainScope) => { map['mainScope'] = mainScope; },
            set: (key, ref) => { map[key] = ref; },
            get: (key) => { return map[key] || null; }
        };
    }
})();